module.exports = __webpack_public_path__ + "img/mob4meter.1dfb2dec.svg";